import FACILITY1 from "../assets/facility/Facility1.jpeg";
import FACILITY2 from "../assets/facility/Facility2.jpeg";
import FACILITY3 from "../assets/facility/Facility3.jpeg";
import FACILITY5 from "../assets/facility/Facility5.jpeg";
import FACILITY6 from "../assets/facility/Facility6.jpeg";
import FACILITY7 from "../assets/facility/Facility7.jpeg";
import FACILITY8 from "../assets/facility/Facility8.jpeg";
import FACILITY9 from "../assets/facility/Facility9.jpeg";
import FACILITY10 from "../assets/facility/Facility10.jpeg";
import FACILITY11 from "../assets/facility/Facility11.jpeg";
import FACILITY12 from "../assets/facility/Facility12.jpeg";
import FACILITY13 from "../assets/facility/Facility13.jpeg";
import FACILITY14 from "../assets/facility/Facility14.jpeg";

export const facilitiesConstant = [
 {
    id:"fac_001",
    nameOfInstrument:"Tubular Furnace",
    imageURL:FACILITY1,
    description:""
 },{
    id:"fac_002",
    nameOfInstrument:"Agilent offline GC",
    imageURL:FACILITY2,
    description:""
 },{
    id:"fac_003",
    nameOfInstrument:"Thermo Scientific HPLC",
    imageURL:FACILITY3,
    description:""
 },{
    id:"fac_005",
    nameOfInstrument:"Near Ambient Pressure XPS",
    imageURL:FACILITY5,
    description:""
 },{
    id:"fac_007",
    nameOfInstrument:"MilliQ Water System",
    imageURL:FACILITY7,
    description:""
 },{
    id:"fac_008",
    nameOfInstrument:"Oven",
    imageURL:FACILITY8,
    description:""
 },{
    id:"fac_009",
    nameOfInstrument:"Muffle Furnace",
    imageURL:FACILITY9,
    description:""
 },{
    id:"fac_ 010",
    nameOfInstrument:"Amar High Pressure Batch Reactor",
    imageURL:FACILITY10,
    description:""
 },{
    id:"fac_011",
    nameOfInstrument:"Hydraulic Press",
    imageURL:FACILITY11,
    description:""
 },{
    id:"fac_012",
    nameOfInstrument:"Centrifuge Eppendrof",
    imageURL:FACILITY12,
    description:""
 },{
   id:"fac_013",
   nameOfInstrument:"High Pressure Fixed Bed Reactor",
   imageURL:FACILITY13,
   description:""
 },{
   id:"fac_014",
   nameOfInstrument:"Atmospheric Pressure Fix Bed Reactor",
   imageURL:FACILITY14,
   description:""
 }
];